/* eslint-disable import/prefer-default-export */
import env from 'utils/env';
import request from './request';

export const getDiscounts = (campaignId, accountCodes) => {
  const endpoint = `${env.aceApi}/1/admin/discounts/campaigns/${campaignId}?accountCodes=${accountCodes}`;
  return request(endpoint);
};
